import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class AppHypotheekgevers extends Vue {
  @Prop()
  public hypotheekgevers!: string[];
}
